
function isDiscountNOK(repo: { langCode: string }, currency: string): boolean {
  const startDate = Date.UTC(2026, 4, 10, 22, 0, 0); // May 11 00:00 CEST (UTC+2)
  const endDate = Date.UTC(2026, 5, 20, 1, 59, 59);  // Jun 19 23:59 CEST (UTC+2)
  const now = Date.now();
  return repo.langCode === "no" && now >= startDate && now < endDate && currency === 'NOK';
}

function isDiscountDKK(repo: { langCode: string }, currency: string): boolean {
  const startDate = Date.UTC(2026, 4, 14, 22, 0, 0); // May 15 00:00 CEST (UTC+2)
  const endDate = Date.UTC(2026, 5, 30, 21, 59, 59);  // Jun 30 23:59 CEST (UTC+2)
  const now = Date.now();
  return repo.langCode === "da" && now >= startDate && now < endDate && currency === 'DKK';
}

export function isDiscount(repo: { langCode: string }, currency: string): boolean {
  return isDiscountNOK(repo, currency) || isDiscountDKK(repo, currency);
}

export function getDiscountPriceKey(repo: { langCode: string }, currency: string): string | null {
  if (isDiscountNOK(repo, currency)) return 'TILBUD_NOK';
  if (isDiscountDKK(repo, currency)) return 'TILBUD';
  return null;
}
